import {
  RequestAddEmailData,
  RequestAddEmailVars,
  RequestVerificationEmailData,
  RequestVerificationEmailVars
} from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import { PublicGraphQL } from '../gql';
import { useMutation } from '@apollo/client';

/**
 * Hook to request a new verification email be sent for a user.
 * @param tenant Tenant where to request the email.
 * @param username Username for which to request email.
 */
const useRequestVerificationEmail = (tenant: string, username: string) => {
  const locationOrigin = window.location.origin;

  const [requestVerificationEmail, { loading, error, data }] = useMutation<
    RequestVerificationEmailData,
    RequestVerificationEmailVars
  >(PublicGraphQL.Mutation.REQUEST_VERIFICATION_EMAIL, {
    client: ApolloClientService.create(Config.MEMBERSHIP_PUBLIC_GQL),
    variables: { locationOrigin, tenant, username }
  });

  const [
    _requestAddOrUpdateEmail,
    { loading: updating, error: updateError, data: updateEmail }
  ] = useMutation<RequestAddEmailData, RequestAddEmailVars>(
    PublicGraphQL.Mutation.REQUEST_ADD_EMAIL,
    {
      client: ApolloClientService.create(Config.MEMBERSHIP_PUBLIC_GQL)
    }
  );

  const requestAddEmail = async (password: string, email: string) => {
    await _requestAddOrUpdateEmail({
      variables: {
        locationOrigin,
        tenant,
        username,
        password,
        email
      }
    });
  };

  return {
    requestVerificationEmail,
    loading,
    error,
    success: data,
    requestAddEmail,
    updateEmail,
    updating,
    updateError
  };
};

export default useRequestVerificationEmail;
